import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../assets/img/LogoYouka.png';
import MobileNav from './MobileNav';

const Header = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);
  const [visible, setVisible] = useState(true);
  const location = useLocation();
  const [isHidden, setIsHidden] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);

  // لإدارة القائمة المنسدلة لـ "Rechtliches"
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const isVisible = prevScrollPos > currentScrollPos || currentScrollPos < 10;
      setPrevScrollPos(currentScrollPos);
      setVisible(isVisible);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [prevScrollPos]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (currentScrollTop > lastScrollTop && currentScrollTop > 100) {
        setIsHidden(true);
      } else {
        setIsHidden(false);
      }

      setLastScrollTop(currentScrollTop <= 0 ? 0 : currentScrollTop);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollTop]);

  // إغلاق القائمة عند تغيير المسار أو عند النقر خارجها
  useEffect(() => {
    setDropdownOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header
      className={`fixed w-full px-[20px] lg:px-[80px] z-20 h-[90px] lg:h-[90px] flex items-center transition-transform duration-300 ${visible ? 'translate-y-0' : '-translate-y-full'}`}
      style={{ backgroundColor: '#f6f7f8', backdropFilter: 'blur(10px)' }}
    >
      <div className="flex flex-row items-center w-full justify-between">
        {/* Logo */}
        <Link to={'/'} className="max-w-[200px]">
          <img src={Logo} alt="Youka GmbH Logo" width="130" height="40" />
        </Link>

        {/* Desktop Nav */}
        <nav className={`flex gap-x-12 font-semibold mt-1 ${isMobile ? 'hidden' : ''}`}>
          <Link to={'/'} className="text-[#103d5b] hover:text-primary transition">Home</Link>
          <Link to={'/UnsereMission'} className="text-[#103d5b] hover:text-primary transition">Unsere Mission</Link>
          <Link to={'/Projekte'} className="text-[#103d5b] hover:text-primary transition">Projekte</Link>
          <Link to={'/Kontakt'} className="text-[#103d5b] hover:text-primary transition">Kontakt</Link>

          {/* Rechtliches dropdown */}
          <div className="relative" ref={dropdownRef}>
            <button
              type="button"
              onClick={() => setDropdownOpen((v) => !v)}
              className="text-[#103d5b] hover:text-primary transition inline-flex items-center gap-2"
              aria-haspopup="true"
              aria-expanded={dropdownOpen}
              aria-controls="rechtliches-menu"
            >
              Rechtliches
              <svg
                className={`w-4 h-4 transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : 'rotate-0'}`}
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" />
              </svg>
            </button>

            
            {dropdownOpen && (
              <div
                id="rechtliches-menu"
                role="menu"
                aria-labelledby="rechtliches-button"
                className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-[#f6f7f8] ring-1 ring-black/5 focus:outline-none"
              >
                <ul className="py-2">
                  <li>
                    <Link
                      to="/Impressum"
                      className="block px-4 py-2 text-sm text-[#103d5b] hover:text-[#f6f7f8] hover:bg-[#103d5b]"
                      role="menuitem"
                      onClick={() => setDropdownOpen(false)}
                    >
                      Impressum
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/Datenschutz"
                      className="block px-4 py-2 text-sm text-[#103d5b] hover:text-[#f6f7f8] hover:bg-[#103d5b]"
                      role="menuitem"
                      onClick={() => setDropdownOpen(false)}
                    >
                      Datenschutz
                    </Link>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </nav>
      </div>

      {/* Mobile Nav */}
      {isMobile && <MobileNav />}
    </header>
  );
};

export default Header;
